import { usePerformanceAudienceFormatters } from '../../hooks/usePerformanceAudienceFormatters';
import { PerformanceAudienceSummary } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { Trans } from 'react-i18next';

type FilterSummaryLineProps = {
  summary: PerformanceAudienceSummary;
};

export const FilterSummaryLine: FC<FilterSummaryLineProps> = ({ summary }) => {
  const { formatNumber } = usePerformanceAudienceFormatters();

  return (
    <p className='flex flex-wrap items-center gap-x-1 gap-y-0.5 text-sm text-tertiary-600'>
      <span className='mr-1.5 inline-block size-2 shrink-0 rounded-full bg-green-500' aria-hidden />
      <Trans
        i18nKey='performanceAudience:filters.summaryRich'
        values={{
          googleCount: summary.googleAccountCount,
          metaCount: summary.metaAdAccountCount,
          audienceName: summary.audienceName,
          userCount: formatNumber(summary.audienceUserCount),
        }}
        components={{
          bold: <span className='font-semibold text-primary-900' />,
        }}
      />
    </p>
  );
};
